var React = require('react');

function Section2TopLeftInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("polygon",{"fill":"#FFCCF3","points":"248.569 191 279.554 241.64 227.986 272.068 197 221.428","key":0}),React.createElement("circle",{"cx":"85","cy":"184","r":"36","fill":"#F58C8C","key":1}),React.createElement("circle",{"cx":"12","cy":"252","r":"12","fill":"#E9D8FD","key":2}),React.createElement("polygon",{"fill":"#1765AB","points":"48.964 323.371 24 294.048 47.749 285","key":3}),React.createElement("circle",{"cx":"121","cy":"11","r":"11","fill":"#FED7D7","key":4})]));
}

Section2TopLeftInline.defaultProps = {"width":"280","height":"324","viewBox":"0 0 280 324"};

module.exports = Section2TopLeftInline;

Section2TopLeftInline.default = Section2TopLeftInline;
